import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Divider, Icon, Row, Col, message, Avatar, Select } from 'antd';
import $ from 'jquery';
import './style.css';

// Actions
import { get_users, update_permission } from './actions/permission.action';


const Option = Select.Option;

class Permission extends Component {

    constructor( props ){
        super( props );

        this.state = {
            user_list: []
        }

        this.handlePermissionChange = this.handlePermissionChange.bind( this );

    }

    componentWillMount(){
        this.props.get_users();
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.permission.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }


        if( nextProps.permission.STATUS.CODE === "200" && 
            nextProps.permission.STATUS.MESSAGE === "Successfully Listed Users" ) {

            this.setState({
                user_list: nextProps.permission.OUTPUT.DATA 
            })

        } else if( nextProps.permission.STATUS.CODE === "200" && 
            nextProps.permission.STATUS.MESSAGE === "Successfully Updated Permission" ) {

            message.success( nextProps.permission.STATUS.MESSAGE );

            this.props.get_users();
        }

    }

    handlePermissionChange( id, value ){
        let permission = '';

        value.map( (item, i) => {
            if( i == value.length-1 ){
                permission += item
            } else {
                permission += item + "-"
            }
        })

        this.props.update_permission( id ,permission );

    }

    render() {

        const permission_user_list = this.state.user_list.map( ( item, i ) => <Option key={ item.user_id }>{ item.full_name }</Option> )
        
        const user_list = this.state.user_list.map( ( item, i ) => <li key={ i } className="list">
                <div className="name">
                    <Avatar className="fl_left" src={ item.picture } />&nbsp;&nbsp;&nbsp;
                    <b>{ item.full_name }</b>
                </div>
                <div className="permission">
                    <Select
                        key={ i }
                        mode="tags"
                        style={{ width: '100%' }}
                        placeholder="Please Select"
                        defaultValue={ item.permission.split('-') }
                        onChange={ this.handlePermissionChange.bind( (e) => e.target.value, item.user_id ) }>
                        { permission_user_list }
                    </Select>
                </div>
            </li> )

        return (
            <div className="permission_wrapper">
                
                <Row>
                    <Col span={24}>
                        <h2>
                            <Icon type="team" />
                            &nbsp; Permissions
                        </h2>
                    </Col>
                </Row>

                <Divider />

                <Row>
                    <Col span={24}>
                        <ul className="user_list">
                            { user_list }
                        </ul>
                    </Col>
                </Row>

            </div>
        )
    }
}


function mapStatetoProps( state ){
    return {
        permission: state.permission
    }
}

export default connect( mapStatetoProps, { get_users, update_permission })( Permission );


// WEBPACK FOOTER //
// ./src/pages/permissions/index.js